// No call control: flat RTP counters can also mean silence suppression, hold or
// a suspended tab. Record the observation, never infer a disconnect from it.
export class MediaFlowDiagnostics {
  private counters = new Map<string, { value: number; changedAt: number; stalled: boolean }>();

  observe(stats: Record<string, any>, active: boolean, now: number) {
    const events: { type: string; detail: Record<string, any> }[] = [];
    if (!active) {
      this.counters.clear();
      return events;
    }
    for (const [key, flowDirection] of [["packetsReceived", "inbound"], ["packetsSent", "outbound"]]) {
      const value = stats[key];
      const previous = this.counters.get(key);
      if (!Number.isFinite(value) || value < 0) {
        this.counters.delete(key);
        continue;
      }
      if (!previous || value < previous.value || now < previous.changedAt) {
        this.counters.set(key, { value, changedAt: now, stalled: false });
        continue;
      }
      const elapsedMs = Math.round(now - previous.changedAt);
      if (value > previous.value) {
        if (previous.stalled) events.push({ type: "media_flow_resumed", detail: { flowDirection, elapsedMs } });
        this.counters.set(key, { value, changedAt: now, stalled: false });
      } else if (!previous.stalled && elapsedMs >= 20000) {
        previous.stalled = true;
        events.push({ type: "media_flow_stalled", detail: { flowDirection, elapsedMs } });
      }
    }
    return events;
  }
}
